import { TagColorLabel } from 'enums/monitor-tags';

export const generateTagsColors = (tags, maxTagsCounterSize = 3) => {
  let counter = 0;

  return tags.map((tag) => {
    const editedTag = {
      ...tag,
      color: TagColorLabel[counter],
    };

    counter < maxTagsCounterSize ? (counter += 1) : (counter = 0);

    return editedTag;
  });
};
